import React, { MouseEvent, ReactNode } from 'react'
import { makeStyles, useTheme } from '@mui/styles'
import clsx from 'clsx'

import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import ThemeInterface from '@/theme-interface'

type TodoTypeSelectListOptionProps = {
  label: string | ReactNode,
  active: boolean,
  icon?: ReactNode,
  onClick: (event: MouseEvent) => void,
}
const ICON_SIZE = '20px'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  typeButton: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 3,
    height: 75,
    color: theme.black,
    border: `1px solid ${theme.borderColor}`,
    fontSize: theme.fontSizes.smaller,
    borderRadius: 4,
    backgroundColor: theme.backgroundColor,
    flex: 1,
  },
  active: {
    borderColor: theme.primaryLight,
    backgroundColor: theme.white,
  },
}))

const TodoTypeSelectListOption = (props: TodoTypeSelectListOptionProps) => {
  const theme = useTheme<ThemeInterface>()
  const { icon, label, onClick, active = false } = props
  const classes = useStyles()

  const buttonClass = clsx(classes.typeButton, active && classes.active)
  return (
    <button onClick={onClick} className={buttonClass}>
      {icon && <SVGIcon fill={theme.iconFillColor} svg={icon} height={ICON_SIZE} width={ICON_SIZE} />}
      {label}
    </button>
  )
}

export default TodoTypeSelectListOption
